import { render, staticRenderFns } from "./querRecycleList.vue?vue&type=template&id=0a2b2c14&scoped=true"
import script from "./querRecycleList.vue?vue&type=script&lang=js"
export * from "./querRecycleList.vue?vue&type=script&lang=js"
import style0 from "./querRecycleList.vue?vue&type=style&index=0&id=0a2b2c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b2c14",
  null
  
)

export default component.exports